/**
 * The frames available to try on.
 *
 * Orientation is auto-detected by normalize-model.js — no per-model rotation
 * calibration is needed.
 *
 * Calibration fields, all consumed by normalize-model.js and the try-on scene:
 *
 *   offsetY     Nudge along the face's up axis, in frame-widths. Positive lifts.
 *   offsetZ     Nudge along the face's forward axis. Positive pushes it away.
 *   widthRatio  Frame width as a multiple of measured face width.
 */
export const frames = [
  {
    id: "meridian",
    name: "Meridian",
    shape: "Wayfarer",
    modelUrl: "/assets/glasses-1.glb",
    // offsetY drops the frame onto the eyes. This model's lens centres sit at
    // y=0, level with the bridge anchor, but a reference face's eyes land
    // 0.0436 face widths below that anchor — 0.047 frame widths at this
    // widthRatio — so at 0 the lenses ride high and the eyes sit low in them,
    // leaving the temple and its chrome hinge trim crowding the eye. This is
    // that measured gap, and brings the model into line with the other two.
    calibration: { rotationY: -Math.PI / 2, offsetY: -0.047, offsetZ: 0, widthRatio: 0.93 },
   
    // calibration: { offsetY: -0.03, offsetZ: 0, widthRatio: 0.94 },
  },
  {
    id: "atlas",
    name: "Atlas",
    shape: "Rectangle",
    modelUrl: "/assets/glasses-2.glb",
    // offsetY nudges the frame down onto the eyes: this model's geometry centres
    // slightly higher than glasses-1's, so at 0 it rides up onto the brow.
    calibration: { offsetY: -0.035, offsetZ: 0, widthRatio: 0.95 },
  },
  {
    id: "horizon",
    name: "Horizon",
    shape: "Round",
    modelUrl: "/assets/glasses-3.glb",
    // Same axis layout as glasses-2; a small downward nudge keeps the lenses
    // centred on the eyes after normalize.
    calibration: { offsetY: -0.03, offsetZ: 0, widthRatio: 0.94 },
  },
];
